module.exports = __webpack_public_path__ + "fonts/Visa.4785e0392f5921b6a94b549588dacb0d.svg";